'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @public
 */
var Uppercase = _styledComponents2.default.span.withConfig({
  displayName: 'uppercase__Uppercase'
})(['text-transform:uppercase;']);

/**
 * @private
 */
Uppercase.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node

  /**
   * @private
   */
};Uppercase.displayName = 'Uppercase';

exports.default = Uppercase;
//# sourceMappingURL=index.js.map